(function () {
  // The admin-editable search lists (Linear ENG-369): trending,
  // blocklist and the "Try ..." examples. Rendered on /search-settings/manage. One Save PUTs all three lists; the server
  // (SearchSettings) is the only validator, the limits here only mirror it for the counter.
  // The "Suggested trending" panel lists terms from real searches; Approve / Block POST one term and the
  // server answers with the same body as GET /search-settings, which refreshes the lists above.
  app.controller('SearchSettingsCtrl', [
    "$scope", '$timeout',
    function ($scope, $timeout) {
      var LISTS = ['trending', 'blocklist', 'examples'];
      $scope.max_entry_length = 80;
      $scope.max_counts = { trending: 10, blocklist: 500, examples: 10 };
      $scope.lists = { trending: [], blocklist: [], examples: [] };
      $scope.errors = {};
      $scope.loaded = false;
      $scope.is_saving = false;
      $scope.suggestions = [];
      $scope.suggestions_loaded = false;
      $scope.suggestions_window_days = 7;
      $scope.suggestion_error = '';
      $scope.suggestion_busy = false;
      // True while the lists hold edits the server has not seen; Approve / Block would overwrite them.
      $scope.dirty = false;
      // ng-model goes through this holder: ng-if creates child scopes.
      $scope.form = { trending: '', blocklist: '', examples: '' };
      $scope.notes = { trending: '', blocklist: '', examples: '' };

      // Must stay defined: applyData only applies its data once scope.init is truthy.
      $scope.init = function () {};

      function csrf_token() {
        return $('meta[name="csrf-token"]').attr('content');
      }

      function take(settings) {
        if (!settings) return;
        LISTS.forEach(function (list) {
          if (Array.isArray(settings[list])) $scope.lists[list] = settings[list].slice();
        });
        $scope.dirty = false;
      }

      // Throws the unsaved edits away and re-reads the stored lists.
      $scope.discard = function () {
        $scope.suggestion_error = '';
        $scope.errors = {};
        load();
      }

      function load() {
        // Fires on its own at init, so it must not raise the loading overlay (fe.rules.md FE-1).
        $.ajax({
          url: $scope.search_settings_url,
          type: 'GET',
          dataType: 'json',
          cache: false,
          global: false,
          success: function (rs) {
            $timeout(function () {
              take(rs && rs.settings);
              $scope.loaded = true;
            });
          },
          error: function () {
            $timeout(function () {
              toastr.error("Could not load the search settings");
            });
          }
        });
      }

      function load_suggestions() {
        // Fires on its own at init, so no loading overlay (fe.rules.md FE-1).
        $.ajax({
          url: $scope.search_settings_url + '/suggestions',
          type: 'GET',
          dataType: 'json',
          cache: false,
          global: false,
          success: function (rs) {
            $timeout(function () {
              if (rs && Array.isArray(rs.data)) $scope.suggestions = rs.data;
              if (rs && rs.window_days) $scope.suggestions_window_days = rs.window_days;
              $scope.suggestions_loaded = true;
            });
          },
          error: function () {
            $timeout(function () {
              $scope.suggestions_loaded = true;
              $scope.suggestion_error = "Could not load the suggestions";
            });
          }
        });
      }

      $scope.$watch('search_settings_url', function (url) {
        if (url && !$scope.loaded) {
          load();
          load_suggestions();
        }
      });

      // action is 'approve' or 'block'; the row stays until the server accepts the term.
      $scope.decide = function (suggestion, action) {
        if ($scope.suggestion_busy || $scope.is_saving) return;
        if ($scope.dirty) {
          $scope.suggestion_error = "Save your list changes first (or discard them)";
          return;
        }
        // The blocklist matches whole words, so a one-word block hides every term containing it.
        if (action === 'block' && !/\s/.test(suggestion.term.trim())) {
          if (!window.confirm('Blocking "' + suggestion.term + '" hides every trending or suggested term containing this word as a whole word. Continue?')) return;
        }
        $scope.suggestion_busy = true;
        $scope.suggestion_error = '';
        // No global: false -- the click is user-initiated (fe.rules.md FE-1).
        $.ajax({
          url: $scope.search_settings_url + '/' + action,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({ term: suggestion.term }),
          headers: { 'X-CSRF-Token': csrf_token() },
          // Required for the same reason as in save(): a refused call gets a JS redirect.
          dataType: 'json',
          cache: false,
          success: function (rs) {
            $timeout(function () {
              $scope.suggestion_busy = false;
              take(rs && rs.settings);
              // The blocklist matches per word, so a block can invalidate other rows: reload them all.
              if (action === 'block') load_suggestions();
              else $scope.suggestions = $scope.suggestions.filter(function (s) { return s !== suggestion; });
            });
          },
          error: function (xhr) {
            $timeout(function () {
              $scope.suggestion_busy = false;
              var rs = xhr.responseJSON;
              $scope.suggestion_error = (rs && rs.message) || "An Unexpected Error Occurred!";
            });
          }
        });
      }

      $scope.add = function (list) {
        var value = ($scope.form[list] || '').replace(/\s+/g, ' ').trim();
        $scope.notes[list] = '';
        delete $scope.errors[list];
        if (value === '') return;
        if (value.length > $scope.max_entry_length) {
          $scope.notes[list] = 'Entries must be at most ' + $scope.max_entry_length + ' characters';
          return;
        }
        if ($scope.lists[list].length >= $scope.max_counts[list]) {
          $scope.notes[list] = 'At most ' + $scope.max_counts[list] + ' entries';
          return;
        }
        var lower = value.toLowerCase();
        if ($scope.lists[list].some(function (e) { return e.toLowerCase() === lower; })) {
          $scope.notes[list] = 'Already in the list';
          return;
        }
        $scope.lists[list].push(value);
        $scope.dirty = true;
        $scope.form[list] = '';
      }

      $scope.remove = function (list, index) {
        $scope.lists[list].splice(index, 1);
        $scope.dirty = true;
        $scope.notes[list] = '';
        delete $scope.errors[list];
      }

      // Enter adds the entry. preventDefault is kept so the key never submits an
      // enclosing form if the card is ever placed inside one.
      $scope.on_keydown = function (e, list) {
        if (e.keyCode === 13) {
          e.preventDefault();
          $scope.add(list);
        }
      }

      $scope.save = function () {
        if ($scope.is_saving || $scope.suggestion_busy) return;
        $scope.is_saving = true;
        $scope.errors = {};
        // No global: false -- the Save click is user-initiated (fe.rules.md FE-1).
        $.ajax({
          url: $scope.search_settings_url,
          type: 'PUT',
          contentType: 'application/json',
          data: JSON.stringify({
            trending: $scope.lists.trending,
            blocklist: $scope.lists.blocklist,
            examples: $scope.lists.examples
          }),
          headers: { 'X-CSRF-Token': csrf_token() },
          // Required: a refused (non-admin) call gets the turbolinks gem's redirect back as
          // HTTP 200 text/javascript running Turbolinks.visit. With dataType 'json' jQuery
          // fails to parse it and calls error instead of executing it.
          dataType: 'json',
          cache: false,
          success: function (rs) {
            $timeout(function () {
              $scope.is_saving = false;
              take(rs && rs.settings);
              if (rs && rs.succeed) toastr.success(rs.message, '', { escapeHtml: true });
              else toastr.error((rs && rs.message) || "An Unexpected Error Occurred!", '', { escapeHtml: true });
            });
          },
          error: function (xhr) {
            $timeout(function () {
              $scope.is_saving = false;
              var rs = xhr.responseJSON;
              // 422: the server list is authoritative, but keep the admin's unsaved edits
              // and show each message next to its own list.
              if (xhr.status === 422 && rs) {
                $scope.errors = rs.errors || {};
                toastr.error(rs.message || "Search settings were not saved", '', { escapeHtml: true });
              } else {
                toastr.error((rs && rs.message) || "An Unexpected Error Occurred!", '', { escapeHtml: true });
              }
            });
          }
        });
      }
    }
  ]);

}).call(this);
